/**
 * Resolve the location to show for an event.
 *
 * Mirrors the server-rendered event page, which falls back from the event's own
 * location to the hosting business's location:
 *   displayLocation = eventLocation or businessLocation
 *
 * Many events have no `locationId` of their own because they happen at the
 * host's venue, so this recovers the address for the details drawer.
 *
 * @param {object} event — normalized event (locationId, optional location)
 * @param {object} business — hosting business (locationId)
 * @param {Array} locations — location records with { id, name, address, phone }
 * @returns {object|null}
 */
export function resolveEventLocation(event, business, locations = []) {
    if (event?.location) return event.location;
    const find = (id) => (id ? locations.find((l) => l.id === id) || null : null);
    return find(event?.locationId) || find(business?.locationId) || null;
}
